import ajaxRequest from './ajax'
import qs from "qs"

export const query_tags = params => {
    return ajaxRequest.get("common/tag/query_tags?" + qs.stringify(params))
}


// WEBPACK FOOTER //
// ./src/api/tag.js